/* 符合特殊字符和空格 */
const spacialPattern=/[`~!￥¥@%#$^&*()=|{}':;',\\\[\]\.<>\/?~！\@\%\￥……&*（）——|{}【】'；：""'。，、？\s]/g;
/* 符合数字以外 */
const exceptNumberPattern=/[^0-9]/g;
/* 符合中文字符 */
const chinesePattern = /[\u4e00-\u9fa5]/g;
/* 符合中文字符以外 */
const exceptChinesePattern = /[^\u4e00-\u9fa5]/g;
/* 符合数字和英文以外 */
const exceptNumberAndEnglishPattern = /[^A-Za-z0-9]/g;
/* 符合数字和英文X以外 驾驶证专用 */
const exceptNumberAndXPattern = /[^Xx0-9]/g;
/* 符合中文，数字和英文以外 */
const exceptCNEPattern = /[^\w\u4E00-\u9FA5]/g; // /[^\a-\z\A-\Z0-9\u4E00-\u9FA5]/g;

const pattern = {
  special: spacialPattern,
  exceptNumber: exceptNumberPattern,
  chinese: chinesePattern,
  exceptChinese: exceptChinesePattern,
  exceptNumberAndEnglish: exceptNumberAndEnglishPattern,
  exceptCNE: exceptCNEPattern,
  exceptNumAndX: exceptNumberAndXPattern,
}

export const mixins = {
  methods: {
    // 旧版 替换对象值
    replaceInput(args) {
      const {object, key, filter} = args
      for (let term of filter) {
        if (term === 'upper') {
          object[key] = object[key].toUpperCase()
        } else {
          const value = object[key].replace(pattern[term], '')
          object[key] = value
        }
      }
    },
  }
}